import React, { createContext, useContext, useState, useCallback } from "react";
import { ContactDialog } from "@/components/landing/ContactDialog";

const ContactContext = createContext(null);

export const ContactProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({ service: "", source: "" });

  const openContact = useCallback((opts = {}) => {
    setPrefill({
      service: opts.service || "",
      source: opts.source || "",
    });
    setOpen(true);
  }, []);

  return (
    <ContactContext.Provider value={{ openContact }}>
      {children}
      <ContactDialog open={open} onOpenChange={setOpen} prefill={prefill} />
    </ContactContext.Provider>
  );
};

export const useContact = () => {
  const ctx = useContext(ContactContext);
  if (!ctx) throw new Error("useContact must be used within ContactProvider");
  return ctx;
};
